const AffiliatePageLangKey = [
	//'btn_add_new'
] as const

type IAffiliatePageLangKey = typeof AffiliatePageLangKey[number]

export type IAffiliatePageLang = {
	affiliate_page: Record<IAffiliatePageLangKey, string>
}

const langEntries = AffiliatePageLangKey.map(
	(key: IAffiliatePageLangKey) => [key, `affiliate_page.${key}`]
)

const langObj: Record<IAffiliatePageLangKey, string> = Object.fromEntries(langEntries)

export const AFFILIATE_PAGE_LANG_KEY: IAffiliatePageLang = {
	affiliate_page: langObj
}
